<template>
  <div :class="['logo-item', discountType]">
    <div class="icon-container" @click="clickMore" tabindex="0" :aria-label="ariaformate()">
      <img class="logo-icon" :src="logoImg" v-if="showLogo" aria-hidden="true" />
      <img class="logo-icon-right" src="./images/right.png" alt v-if="isShowRight" aria-hidden="true" />
      <img
        class="logo-icon-tips"
        src="./images/vip-tips.png"
        v-if="isVipFirstBuy && commodityVipFirst && commodityVipFirst.ruleDesc"
        aria-hidden="true"
      />
    </div>
    <div
      :class="[isVipFirstBuy ? 'vip-timer' : isNoAtmosphere ? 'no-atmosphere-timer' : 'normal-timer']"
      v-if="isShowTimer"
      aria-hidden="true"
    >
      <!-- 预热 -->
      <template v-if="isPreHot">
        <div>{{ formatDate(startTime) }}开始</div>
      </template>
      <template v-else-if="endTime">
        <span class="to-end-time" v-if="!isEndTime">距结束</span>
        <v-count-down
          ref="count"
          :start="startTime"
          :current="currentTime"
          :end="endTime"
          :startFun="refresh"
          :endFun="endFun"
        ></v-count-down>
      </template>
    </div>
    <v-os-popup
      title="会员先享购说明"
      footerText="我知道了"
      :minHeightFill="false"
      :footerShow="true"
      :show="showRule"
      @close="closeRule"
      @footerClick="closeRule"
      class="vip-pop"
      container="body"
    >
      <div class="vip-rule" v-html="commodityVipFirst && commodityVipFirst.ruleDesc"></div>
    </v-os-popup>
  </div>
</template>

<script>
import { grouponEndPopup } from '@/components'
import interval from '@/utils/interval'
import { mapState, mapGetters, mapActions } from 'vuex'
import { app } from '@/utils'

export default {
  name: 'LogoItem',
  data() {
    return {
      isEndTime: false,
      showRule: false // 是否展示规则
    }
  },
  computed: {
    ...mapState('detailv3', {
      discountDetail: state => state.skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail,
      spuInfo: 'spuInfo',
      skuInfo: 'skuInfo',
      skuCurrentTime: 'skuCurrentTime'
    }),
    ...mapGetters('detailv3', [
      'skuId',
      'spuId',
      'discountType',
      'commonTrackData',
      'isLottery',
      'isVipFirstBuy',
      'commodityVipFirst',
      'saleStatus',
      'getSelectParams',
      'commodityBigPromotion',
      'isPreHot',
      'interventureLogoPic',
      'isNoAtmosphere',
      'isCustomAtmosphere',
      'customAtmosphereInfo'
    ]),
    isShowRight() {
      return (
        ['group', 'quickbuy'].includes(this.discountType) ||
        (this.customAtmosphereInfo?.logoPic && this.customAtmosphereInfo?.linkUrl)
      )
    },
    // 秒杀、一分团、全款预订、定金预售、会员先享购、大促、礼盒，显示倒计时格式：“距结束：2天12：18：32”
    // 全款预定、定金预售、会员先享购预热阶段，显示格式： “11月11日 00：00开始”
    isShowTimer() {
      return (
        ['quickbuy', 'fullpay', 'deposit', 'vip', 'group'].includes(this.discountType) ||
        (this.customAtmosphereInfo?.countdown && this.discountDetail.commodityQuickBuy.endTime) ||
        (this.commodityBigPromotion?.countdownFlag && this.commodityBigPromotion?.endTime)
      )
    },
    // 是否显示氛围logo
    showLogo() {
      if (this.isCustomAtmosphere) return !!this.customAtmosphereInfo?.logoPic
      return (
        ['deposit', 'fullpay', 'group', 'quickbuy', 'vip'].includes(this.discountType) ||
        (this.commodityBigPromotion && this.commodityBigPromotion.logoImgUrl)
      )
    },
    // 氛围logo图片,大促礼盒干预，其余全部前端写死
    logoImg() {
      if (this.isCustomAtmosphere) return this.customAtmosphereInfo?.logoPic
      return (
        this.interventureLogoPic ||
        this.commodityBigPromotion?.logoImgUrl ||
        require(`./images/${this.discountType}-logo.png`)
      )
      // return this.commodityBigPromotion && this.commodityBigPromotion.logoImgUrl
      //   ? this.commodityBigPromotion.logoImgUrl
      //   : require(`./images/${this.discountType}-logo.png`)
    },
    startTime() {
      let time = 0
      if (this.discountType === 'fullpay') {
        time = this.discountDetail.commodityFullPay.startTime
      } else if (this.discountType === 'deposit') {
        time = this.discountDetail.commodityDeposite.depositStartTime
      } else if (this.discountType === 'quickbuy') {
        time = this.discountDetail.commodityQuickBuy.startTime
      } else if (this.discountType === 'quickbuypreheat') {
        time = this.discountDetail.commodityQuickBuyPreHeat.startTime
      } else if (this.discountType === 'vip') {
        time = this.commodityVipFirst.startTime
      } else if (this.commodityBigPromotion && this.commodityBigPromotion.countdownFlag) {
        time = this.commodityBigPromotion?.startTime
      }
      return parseInt(time)
    },
    currentTime() {
      return parseInt(this.skuCurrentTime) || interval.time
    },
    endTime() {
      let time = 0
      if (this.discountType === 'fullpay') {
        time = this.isPreHot
          ? this.discountDetail.commodityFullPay.startTime
          : this.discountDetail.commodityFullPay.endTime
      } else if (this.discountType === 'quickbuy') {
        time = this.discountDetail.commodityQuickBuy.endTime
      } else if (this.discountType === 'quickbuypreheat') {
        time = this.discountDetail.commodityQuickBuyPreHeat.endTime
      } else if (this.discountType === 'deposit') {
        time = this.isPreHot
          ? this.discountDetail.commodityDeposite.depositStartTime
          : this.discountDetail.commodityDeposite.depositEndTime
      } else if (this.discountType === 'group') {
        time = this.discountDetail.commodityGroupon.expireTime
      } else if (this.discountType === 'vip') {
        time = this.isPreHot ? this.commodityVipFirst.startTime : this.commodityVipFirst.endTime
      } else if (this.customAtmosphereInfo?.countdown && this.discountDetail.commodityQuickBuy.endTime) {
        time = this.discountDetail.commodityQuickBuy.endTime
      } else if (this.commodityBigPromotion && this.commodityBigPromotion.countdownFlag) {
        time = this.commodityBigPromotion.endTime
      }
      return parseInt(time)
    },
    // 阅读器阅读内容，当前活动名称
    disCountTypeName() {
      switch (this.discountType) {
        case 'vip':
          return '会员先享购'
        case 'group':
          return 'V拼团'
        case 'deposit':
          return '定金预售'
        case 'fullpay':
          return '全款预订'
        case 'quickbuy':
          return '抢购活动'
        case 'bigpromotion':
          return '大促礼盒'
        default:
          return '普通活动'
      }
    }
  },
  methods: {
    ...mapActions('detailv3', ['refresh', 'commonSubmit']),
    test() {
      alert(111)
    },
    //无障碍适配，阅读文本
    ariaformate() {
      if (this.isPreHot) {
        return `${this.disCountTypeName}，将于${this.formatDate(this.startTime)}开始`
      }
      if (!this.isEndTime && this.endTime && this.endTime) {
        return `${this.disCountTypeName}，将于${this.formatDate(this.endTime)}结束`
      }
    },
    clickMore() {
      const { page_name, sku_id } = this.commonTrackData
      this.$track({
        cfrom: '174|001|01|077',
        event_id: '174|001|01|077',
        page_name,
        sku_id,
        info_content: 8
      })
      // 跳转连接
      if (this.discountType === 'group') {
        this.jump(this.discountDetail.commodityGroupon?.grouponChannel)
      } else if (this.discountType === 'quickbuy') {
        this.jump(this.discountDetail.commodityQuickBuy.actUrl)
      } else if (this.discountType === 'vip' && this.commodityVipFirst.ruleDesc) {
        this.showRule = true
      } else if (this.customAtmosphereInfo?.linkUrl) {
        this.jump(this.customAtmosphereInfo.linkUrl)
      } else if (this.commodityBigPromotion && this.commodityBigPromotion.resourceLink) {
        this.jump(this.commodityBigPromotion.resourceLink)
      }
    },
    jump(url) {
      app.openNewWebview({
        url
      })
    },
    endFun() {
      this.isEndTime = true
      if (this.isLottery) {
        // 拼团结束
        grouponEndPopup({
          result: {
            status: 1,
            otherGroupons: this.discountDetail.commodityGroupon?.grouponChannel,
            commodityFlag: this.saleStatus ? 1 : 0
          },
          selectData: this.getSelectParams,
          spuInfo: this.spuInfo,
          skuInfo: this.skuInfo,
          commonBuy: () => {
            this.commonSubmit({ isAdd: false })
          }
        })
      } else {
        // 需要整个页面刷新，refresh只能刷新当前sku
        if (this.isVipFirstBuy) {
          window.location.replace(`/wap/product/${this.spuId}?skuId=${this.skuId}&channel=vip`)
        } else {
          this.refresh()
        }
      }
    },
    closeRule() {
      this.showRule = false
    },
    formatDate(value) {
      const month = new Date(value).getMonth() + 1
      const day = new Date(value).getDate()
      let hour = new Date(value).getHours()
      let min = new Date(value).getMinutes()
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      return month + '月' + day + '日 ' + hour + ':' + min
    }
  }
}
</script>

<style scoped lang="scss">

.logo-item {
  @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .icon-container {
    @include flex-center;
    .logo-icon-right {
      width: 33px;
      height: 33px;
      margin-left: 15px;
    }
    .logo-icon-tips {
      width: 33px;
      height: 33px;
      margin-left: 15px;
    }
    .logo-icon {
      width: auto;
      height: 45px;
    }
  }
  &.group {
    .logo-icon {
      width: 140px;
    }
  }
  &.vip {
    .logo-icon {
      width: 237px;
    }
  }
  .normal-timer,
  .no-atmosphere-timer,
  .vip-timer {
    margin-top: 22px;
    font-size: 30px;
    @include os-font-weight(30, 50);
    @include flex-center();
    letter-spacing: 0.8px;
    @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
    .to-end-time {
      @include os-font-weight(999, 40);
      padding-right: 18px;
    }
    ::v-deep .v-count-down {
      .day {
        @include os-font-weight(30, 40);
      }
      .tbg {
        min-width: 42px;
        display: inline-block;
        text-align: center;
      }
    }
  }

  .vip-timer {
    color: #ffc121 !important;
  }
  .no-atmosphere-timer {
    color: #f10313 !important;
  }
}
.vip-rule {
  word-break: break-all;
  @include fontColor(#666, rgba(255, 255, 255, 0.5));
  font-size: 36px !important;
  line-height: 66px !important;
  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5,
  ::v-deep h6 {
    @include fontColor(#333, rgba(255, 255, 255, 0.9));
    font-size: 36px !important;
    @include os-font-weight(36, 50);
    // padding: 50px 0 20px 0;
  }
  ::v-deep strong {
    @include fontColor(#333, rgba(255, 255, 255, 0.9));
    @include os-font-weight(36, 50);
  }
  ::v-deep p {
    line-height: 66px !important;
    font-size: 36px !important;
  }
}
</style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .normal-timer,
  .vip-timer {
    font-size: 24px;
  }
}
</style>
<style lang="scss" scoped src="../../../index/dark-popup.scss"></style>
